import { useEffect, useState } from 'react';
import { ChevronDown } from 'lucide-react';

const TOP_SLOP_PX = 8;
const BOTTOM_SLOP_PX = 32;

function scrollParent(): HTMLElement | null {
  const main = document.querySelector('main');
  return main instanceof HTMLElement ? main : null;
}

function moreContentBelow(main: HTMLElement): boolean {
  return main.scrollHeight - main.clientHeight > BOTTOM_SLOP_PX;
}

function atTop(main: HTMLElement): boolean {
  return main.scrollTop <= TOP_SLOP_PX;
}

export default function ScrollForMoreHint() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const main = scrollParent();
    if (!main) return;

    const update = () => {
      setVisible(moreContentBelow(main) && atTop(main));
    };

    update();
    main.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    const observer = new ResizeObserver(update);
    observer.observe(main);
    if (main.firstElementChild instanceof HTMLElement) {
      observer.observe(main.firstElementChild);
    }

    return () => {
      main.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
      observer.disconnect();
    };
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      aria-label="Scroll down for more"
      onClick={() => {
        const main = scrollParent();
        if (!main) return;
        main.scrollBy({ top: Math.round(main.clientHeight * 0.85), behavior: 'smooth' });
      }}
      className="fixed bottom-6 left-1/2 z-30 flex h-12 w-12 -translate-x-1/2 items-center justify-center rounded-full border border-gray-500 bg-gray-500 text-white shadow-bento dark:border-gray-400 dark:bg-gray-400 dark:text-gray-950 xl:left-[calc(50%+9rem)]"
    >
      <ChevronDown className="h-6 w-6 motion-safe:animate-bounce" strokeWidth={2.5} aria-hidden="true" />
    </button>
  );
}
